bz_app.controller('HomeownerServiceRequestsCtrl', [
  function () {
    this.noProjectsImageUrl = () =>
      bzGlobal.applicationConstants.filepicker.stock_image_url +
      '_thumbnails/homeowner-no-projects.png'
  },
])
